
export const NameRegex = RegExp(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/);
export const EmailRegex = RegExp(/^([a-zA-Z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/);
export const PasswordRegex = RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*[`´'"°¬À-ÿ]).{8,12}$/);
export const PhoneRegex = RegExp(/^[0-9]{10}$/);
export const codeRegex = RegExp(/^[0-9]\d*$/);
export const amountRegex = RegExp(/^([0-9]+\.[0-9]{2,2})$/);
export const IncludeUpper = RegExp(/^(?=.*[A-Z])/);
export const IncludeNumber = RegExp(/[0-9]|[\u0080-\u024F]/);
export const SizeWithoutAccents = RegExp(/^(?!.*[`´'"°¬À-ÿ]).{8,12}$/);
export const JWTValid = RegExp(/^[A-Za-z0-9-_]+$/);

export const EIGHTEEN_YEARS = new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().split('.')[0];
